import {
  postRequest,
  patchRequest,
  postFormDataRequest,
  getRequest,
  deleteRequest
} from "../lib/utils/request";

export const getAllAPI = async (
  apiHost,
  { limit, offset, sortField, sortDir },
  requestOptions
) => {
  return await getRequest(
    `${apiHost}/v1/admins?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}`,
    requestOptions
  );
};

export const getAPI = async (apiHost, { uid }, requestOptions) => {
  return await getRequest(`${apiHost}/v1/admins/${uid}`, requestOptions);
};

export const createAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(`${apiHost}/v1/admins`, data, requestOptions);
};

export const updateAPI = async (apiHost, data, requestOptions) => {
  return await patchRequest(
    `${apiHost}/v1/admins/${data.uid}`,
    data,
    requestOptions
  );
};

export const deleteAPI = async (apiHost, { uid }, requestOptions) => {
  return await deleteRequest(`${apiHost}/v1/admins/${uid}`, requestOptions);
};



// WEBPACK FOOTER //
// ./src/common/admin/api.js